<template>
  <div
    :class="[
      isSelected || isFavorite
        ? 'bg-gray-500'
        : isDisabled
        ? ''
        : 'lg:hover:bg-gray-600',
      isDisabled ? '' : 'cursor-pointer',
    ]"
    class="
      flex
      items-center
      border-transparent
      transform
      transition
      justify-between
      mb-2
      rounded-lg
      music-card
    "
  >
    <div class="flex items-center">
      <div class="w-32 md:w-36 relative p-2">
        <div
          :class="{
            'image-placeholder w-28 h-28 md:w-32 md:h-32 rounded-md':
              !isImageLoaded,
          }"
        >
          <img
            class="rounded-md overflow-hidden"
            :src="imageUrl"
            @load="isImageLoaded = true"
          />
        </div>
        <div
          v-if="numberSelection || isFavorite"
          :class="numberSelection || isFavorite ? 'opacity-100' : ''"
          class="
            absolute
            w-12
            h-12
            text-xs
            bg-gray-600
            border
            text-white
            flex
            justify-center
            items-center
            border-gray-300
            rounded-full
            opacity-0
            inset-1/2
            transform
            -translate-x-1/2 -translate-y-1/2
          "
        >
          <span v-if="numberSelection">{{ numberSelection }}</span>
          <div class="mb-0.5">
            <Icon v-if="isFavorite" id="star" />
          </div>
        </div>
      </div>
      <div class="flex-1 ml-4 text-sm">
        <p class="text-white mb-1">{{ title }}</p>
        <span class="text-gray-300">{{ subtitle }}</span>
      </div>
    </div>
    <div
      v-if="icon"
      @click="$emit('onIcon')"
      class="
        music-item-icon
        w-20
        h-20
        justify-center
        align-middle
        flex
        hover:bg-gray-700
        rounded
        mr-2
      "
    >
      <Icon :id="icon" />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { MusicCoverImage } from '@/types'

@Component({
})
export default class MusicCard extends Vue {
  @Prop() numberSelection!: number
  @Prop() title!: string
  @Prop() subtitle!: string
  @Prop({ type: Array, default: () => [] }) images!: MusicCoverImage[]
  @Prop() icon!: 'dots' | 'arrowRight' | 'dragIcon'
  @Prop() isFavorite!: boolean
  @Prop() isSelected!: boolean
  @Prop() isDisabled!: boolean

  isImageLoaded = false

  get imageUrl (): string|null {
    if (this.images.length === 0) return null
    else if (this.images.length === 1) return this.images[0].url
    else return this.images[1].url
  }
}
</script>

<style lang="scss" scoped>
// Animation
@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

.animated-background {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f6f6;
  background: linear-gradient(90deg, #424242 8%, #1c1c1c 18%, #343434 33%);
  background-size: 800px 104px;
  position: relative;
}

.image-placeholder {
  @extend .animated-background;
}
</style>
